// @ts-ignore
import GLightbox from 'glightbox';

export class Lightbox {
  selector: string;
  lightboxes: NodeListOf<HTMLElement>;

  constructor() {
    this.selector = 'data-lightbox';
    this.lightboxes = document.querySelectorAll('[' + this.selector + ']');
    this.init();
  }

  init() {
    this.lightboxes.forEach((lightbox) => {
      let key = lightbox.getAttribute(this.selector);
      let zoomable = true;
      let draggable = true;
      if (lightbox.dataset.lightboxVideo || lightbox.dataset.lightboxContent) {
        zoomable = false;
        draggable = false;
      }
      const glightbox = GLightbox({
        selector: '[' + this.selector + '="' + key + '"]',
        skin: 'clean',
        zoomable: zoomable,
        draggable: draggable,
        touchNavigation: true,
        loop: false,
        autoplayVideos: true,
        closeButton: true,
        svg: {
          close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/></svg>',
          next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
          prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>'
        },
        plyr: {
          css: '../Css/plyr.css',
          js: 'plyr.min.js',
          config: {
            ratio: '16:9',
            muted: false,
            controls: [
              'play-large',
              'play',
              'progress',
              'current-time',
              'mute',
              'volume',
              'settings',
              'fullscreen'
            ],
          }
        }
      });
      if (lightbox.dataset.lightboxContent) {
        let originalContent = document.querySelector(lightbox.dataset.lightboxContent);
        let originalParent = originalContent.parentNode;
        if (lightbox.dataset.lightboxVideo) {
          let videoType = lightbox.dataset.lightboxVideo;
          switch (videoType) {
            case 'youtube':
              break;
            case 'vimeo':
              break;
            default:
              let player: HTMLVideoElement = originalContent.querySelector('video');
              if (player) {
                glightbox.on('open', () => {
                  player.play();
                });
                glightbox.on('close', () => {
                  player.pause();
                });
              }
          }
        }
        glightbox.on('open', () => {
          let lightboxContentContainer = glightbox.getActiveSlide().querySelector('.gslide-media');
          lightboxContentContainer.innerHTML = '';
          lightboxContentContainer.appendChild(originalContent);
          lightboxContentContainer.classList.add('h-auto');
        });
        glightbox.on('close', () => {
          originalParent.appendChild(originalContent);
        });
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new Lightbox();
});
